import script from "./new-password-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./new-password-modal.vue?vue&type=script&setup=true&lang=ts"

import "./new-password-modal.scss?vue&type=style&index=0&lang=scss&external"
import "./new-password-modal.vue?vue&type=style&index=1&id=657449fa&lang=css"

const __exports__ = script;

export default __exports__